var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar }
      }),
      _c(
        "div",
        { staticClass: "navbar-top" },
        [
          _vm.isShowCopyRight === "true"
            ? [
                _vm.theme == "blueTheme"
                  ? _c("img", {
                      staticClass: "navbar-blueImg",
                      attrs: {
                        src: require("../../assets/blueThemeBg/logo.png"),
                        alt: ""
                      }
                    })
                  : _vm._e(),
                _vm.theme == "redTheme"
                  ? _c("img", {
                      staticClass: "navbar-redImg",
                      attrs: {
                        src: require("../../assets/redThemeBg/logo.png"),
                        alt: ""
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.isShowCopyRight === "false" ? [_vm._m(0)] : _vm._e(),
          _c("div", { staticStyle: { "margin-left": "40px" } }, [
            _c("span", { staticClass: "topnav", on: { click: _vm.toHome } }, [
              _vm._v("首页")
            ]),
            _c(
              "span",
              { staticClass: "topnav", on: { click: _vm.gotoHelpDoc } },
              [_vm._v("帮助文档")]
            )
          ])
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c("message-entrance", {
            staticClass: "right-menu-item hover-effect",
            staticStyle: { display: "flex" }
          }),
          _c(
            "el-dropdown",
            { staticClass: "avatar-container", attrs: { trigger: "click" } },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "user-avatar",
                  attrs: { src: _vm.images }
                }),
                _c("div", { staticClass: "userinfo" }, [
                  _c("div", { staticStyle: { cursor: "pointer" } }, [
                    _vm._v(_vm._s(_vm.user ? _vm.user.userName + "/" : "张三/"))
                  ]),
                  _c("div", { staticStyle: { cursor: "pointer" } }, [
                    _vm._v(_vm._s(_vm.user ? _vm.user.userId : "100001"))
                  ])
                ]),
                _c("i", { staticClass: "el-icon-caret-bottom" })
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown"
                },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.home($event)
                        }
                      }
                    },
                    [_vm._v(" 首页 ")]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.resource($event)
                        }
                      }
                    },
                    [_vm._v(" 我的收藏 ")]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.logout($event)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("退出")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kkwsTitle" }, [
      _c("span", [_vm._v("智能合规平台")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }